import type { TFunction } from "i18next";
import { extractErrorMessage } from "@/shared/utils";

/** Backend error codes (docs/SUPPORT_API.md) → SupportPage locale keys. */
const FILE_ERROR_KEYS: Record<string, string> = {
  too_many_files: "form.errors.tooManyFiles",
  file_too_large: "form.errors.fileTooLarge",
  unsupported_file_type: "form.errors.notImage",
};

/** `t` must be bound to the SupportPage namespace. */
export function supportErrorMessage(error: unknown, t: TFunction): string {
  const { status, data } = (error ?? {}) as { status?: number; data?: { error?: unknown } };
  const code = typeof data?.error === "string" ? data.error : undefined;

  if (status === 503 || status === 502 || code === "support_unavailable" || code === "support_upstream_error") {
    return t("messages.unavailable");
  }
  if (status === 429) return t("messages.tooManyRequests");
  if (code === "ticket_closed") return t("details.closedNote");
  if (code && code in FILE_ERROR_KEYS) return t(FILE_ERROR_KEYS[code]);
  // 404 bodies are raw English prose, never shown as-is.
  if (status === 404) {
    return code?.startsWith("tenant not pre-provisioned") ? t("messages.tenantNotRegistered") : t("messages.notFound");
  }

  return extractErrorMessage(error, "messages.defaultError", t);
}
